/* =========================================================
   Apple Storytelling Scroll — JS
   - Fade-in + slide-up scroll-triggered (Intersection Observer)
   - Parallax sutil nas imagens (scroll-linked)
   - Compatível com Shopify Theme Editor
   ========================================================= */
(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.assInit === 'true') return;
    section.dataset.assInit = 'true';

    /* ---------- Fade-in ---------- */
    var animatedEls = section.querySelectorAll('[data-ass-animate]');

    if ('IntersectionObserver' in window && animatedEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -80px 0px' }
      );
      animatedEls.forEach(function (el) { observer.observe(el); });
    } else {
      animatedEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---------- Parallax sutil nas imagens ---------- */
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 734px)').matches;

    if (prefersReducedMotion || isMobile) return;

    var medias = section.querySelectorAll('.ass-story__media');
    medias.forEach(function (media) { media.setAttribute('data-parallax', ''); });

    var ticking = false;
    var inView = [];

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (inView.indexOf(entry.target) === -1) inView.push(entry.target);
            } else {
              var i = inView.indexOf(entry.target);
              if (i > -1) inView.splice(i, 1);
            }
          });
        },
        { threshold: 0, rootMargin: '100px 0px 100px 0px' }
      );
      medias.forEach(function (m) { visibilityObserver.observe(m); });
    }

    function updateParallax() {
      var vh = window.innerHeight;
      inView.forEach(function (media) {
        var rect = media.getBoundingClientRect();
        var progress = (vh - rect.top) / (vh + rect.height);
        progress = Math.max(0, Math.min(1, progress));
        var translate = (progress - 0.5) * -30;
        media.style.setProperty('--parallax-y', translate.toFixed(2) + 'px');
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking && inView.length) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateParallax();
  }

  function initAll() {
    document.querySelectorAll('.ass-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Compatibilidade com Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ass-section');
    if (section) initSection(section);
  });
})();